function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import _ from "lodash";
import { defineComponent, ref, computed, watch, getCurrentInstance } from "vue";
import MainEditor from "@/views/mindworks/components/MainEditor.vue";
import { messageSave } from "@/api/message/message";
import AdvertiserDialog from "./advertiser-dialog.vue";
import { typeOptions, triggerOptions, planList, popUpOptions } from "../index";
import MessageContent from "@pt/views/layout/components/warrant-message/content.vue";
import { MessageBox } from "element-ui";
var defaultQuery = {
    lang: "zh",
    zh_title: "",
    zh_content: "",
    en_title: "",
    en_content: "",
    type: "normal",
    users: "all",
    advs: [],
    trigger: "plan_active",
    trigger_value: [],
    send: "immediate",
    send_time: "",
    is_pop_up: 2,
    msg_id: 0
};
export default defineComponent({
    components: {
        MainEditor: MainEditor,
        AdvertiserDialog: AdvertiserDialog,
        MessageContent: MessageContent
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleAdd = function handleAdd(list) {
            formValue.value.advs = list;
        };
        var handleGoBack = function handleGoBack() {
            if (formValue.value[formValue.value.lang + "_title"] !== "" || formValue.value[formValue.value.lang + "_content"] !== "") {
                MessageBox.confirm("\u662F\u5426\u5B58\u4E3A\u8349\u7A3F\uFF1F", "\u63D0\u793A", {
                    type: "warning",
                    confirmButtonText: "\u4FDD\u5B58",
                    distinguishCancelAndClose: true
                }).then(function() {
                    handleSave(true);
                    root.$router.push("/website/station-letter");
                }).catch(function(action) {
                    if (action === "cancel") {
                        root.$router.push("/website/station-letter");
                    }
                });
            } else {
                root.$router.push("/website/station-letter");
            }
        };
        var handleSave = function handleSave(is_draft) {
            var _$ref;
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function(valid) {
                if (valid) {
                    sendLoading.value = true;
                    var _$param = {
                        message_langs: [],
                        is_draft: is_draft,
                        is_pop_up: formValue.value.is_pop_up === 1,
                        type: formValue.value.type
                    };
                    // 更新站内信
                    if (formValue.value.msg_id !== 0) {
                        _$param.id = formValue.value.msg_id;
                        _$param.only_update = true;
                    }
                    if (formValue.value.zh_title && formValue.value.zh_content) {
                        _$param.message_langs.push({
                            lang: "zh-cn",
                            title: formValue.value.zh_title,
                            content: formValue.value.zh_content
                        });
                    }
                    if (formValue.value.en_title && formValue.value.en_content) {
                        _$param.message_langs.push({
                            lang: "en",
                            title: formValue.value.en_title,
                            content: formValue.value.en_content
                        });
                    }
                    if (formValue.value.type === "normal") {
                        if (formValue.value.send === "immediate") {
                            _$param.now_send = true;
                        } else {
                            _$param.now_send = false;
                            _$param.send_time = Date.parse(new Date(formValue.value.send_time).toString()) / 1000;
                        }
                        if (formValue.value.users === "all") {
                            _$param.all_users = true;
                        } else {
                            _$param.all_users = false;
                            _$param.receive_ids = _.map(formValue.value.advs, "adv_id");
                        }
                    } else {
                        _$param.trigger = formValue.value.trigger;
                        _$param.trigger_value = formValue.value.trigger_value.join(",");
                    }
                    messageSave(_$param).then(function(res) {
                        if (!res.data.code) {
                            root.$router.push("/website/station-letter");
                        }
                    }).finally(function() {
                        sendLoading.value = false;
                    });
                }
            });
        };
        var handleLoading = function handleLoading() {
            loading.value = false;
            setTimeout(function() {
                loading.value = true;
            });
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var loading = ref(true);
        var sendLoading = ref(false);
        var formRef = ref(null);
        var formValue = ref(_objectSpread({}, defaultQuery));
        var AdvertiserDialogVisible = ref(false);
        var mainEditorConfig = computed(function() {
            return {
                label: formValue.value.lang + "\u6B63\u6587\uFF1A",
                type: "business",
                subtype: "main-editor",
                prop: formValue.value.lang + "_content"
            };
        });
        var isEditMode = computed(function() {
            return formValue.value.msg_id !== 0;
        });
        var sendButtonLabel = computed(function() {
            return isEditMode.value ? "\u66F4\u65B0" : "\u53D1\u9001";
        });
        var rules = computed(function() {
            return {
                advs: [
                    {
                        required: true,
                        message: "\u8BF7\u9009\u62E9\u5E7F\u544A\u4E3B",
                        trigger: "blur"
                    }, 
                ],
                send_time: [
                    {
                        required: true,
                        message: "\u8BF7\u9009\u62E9\u53D1\u9001\u65F6\u95F4",
                        trigger: "blur"
                    }, 
                ],
                trigger_value: [
                    {
                        required: true,
                        message: "\u8BF7\u9009\u62E9\u5BF9\u5E94\u5957\u9910",
                        trigger: "change"
                    }, 
                ]
            };
        });
        var messageViewer = computed(function() {
            var message_langs = [];
            if (formValue.value.lang === "zh") {
                if (formValue.value.zh_title || formValue.value.zh_content) {
                    message_langs.push({
                        lang: "zh-cn",
                        title: formValue.value.zh_title,
                        content: formValue.value.zh_content
                    });
                }
            } else if (formValue.value.en_title && formValue.value.en_content) {
                message_langs.push({
                    lang: "en",
                    title: formValue.value.en_title,
                    content: formValue.value.en_content
                });
            }
            return message_langs;
        });
        watch(function() {
            return root.$route;
        }, function(to, from) {
            if (JSON.stringify(to.query) !== "{}") {
                formValue.value = _.cloneDeep(Object.assign(to.query, {
                    is_pop_up: Number(to.query.is_pop_up),
                    advs: to.query.advs ? JSON.parse(decodeURIComponent(to.query.advs)) : [],
                    msg_id: to.query.msg_id ? Number(to.query.msg_id) : 0,
                    trigger_value: to.query.trigger_value ? to.query.trigger_value.map(Number) : []
                }));
            }
        }, {
            immediate: true
        });
        return {
            formRef: formRef,
            loading: loading,
            formValue: formValue,
            rules: rules,
            planList: planList,
            sendLoading: sendLoading,
            typeOptions: typeOptions,
            popUpOptions: popUpOptions,
            triggerOptions: triggerOptions,
            sendButtonLabel: sendButtonLabel,
            isEditMode: isEditMode,
            AdvertiserDialogVisible: AdvertiserDialogVisible,
            handleAdd: handleAdd,
            handleSave: handleSave,
            mainEditorConfig: mainEditorConfig,
            handleLoading: handleLoading,
            messageViewer: messageViewer,
            handleGoBack: handleGoBack
        };
    }
});
